// extracted by mini-css-extract-plugin
export default {"container":"DoctorRefinements_container__aNH1g","aside":"DoctorRefinements_aside__nEnfY","title":"DoctorRefinements_title__12RWu"};